export * from './regexp/is-regexp.js';
